import { Component, OnInit } from '@angular/core';
import { Helper } from '@rawlings/core';
import { PHONE_NUMBER } from '@app/member-response-portal/model/constants';

@Component({
  selector: 'app-footer-contact-us',
  templateUrl: './footer-contact-us.component.html',
  styleUrls: ['./footer-contact-us.component.scss']
})
export class FooterContactUsComponent implements OnInit {
    //#region Public Variables
    public PhoneNumber: string;
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    public ngOnInit(): void {
        // eslint-disable-next-line @typescript-eslint/typedef
        const cachePolicy = localStorage.getItem(PHONE_NUMBER);

        if (!Helper.IsEmpty(cachePolicy)){
            this.PhoneNumber = cachePolicy;
        }
    }

    //#endregion Constructor

    //#region Public Methods
    //#endregion Public Methods
}
